<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="all_question"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown
            vs-trigger-click
            class="dd-actions cursor-pointer mr-4 mb-4"
          >
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
            >
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="ArchiveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon
                    icon="SaveIcon"
                    svgClasses="h-4 w-4"
                    class="mr-2"
                  />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->

          <add-edit-new-questionnaire
            :all_data="all_question"
            @reloadItems="getQuestionnaire"
          />
           <div style="margin-top: -10px">
          <v-select
            :clearable="false"
            :options="[
              { label: 'Active', value: 'active' },
              { label: 'Draft', value: 'draft' },
            ]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Status"
            style="width: 150px !important"
            @input="changeStatus"
            v-model="db_status"
          />
        </div>
        </div>
        <!-- <div class="w-100">
          <v-select
            :clearable="false"
            :options="[
              { label: 'Active', value: 'active' },
              { label: 'Draft', value: 'draft' },
            ]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Status"
            class="w-100"
            style="width:150px !important"
            @change="changeStatus"
          />
        </div> -->

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                products.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : products.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="question">Question</vs-th>
        <vs-th sort-key="type">Type</vs-th>
        <!-- <vs-th sort-key="status">Status</vs-th> -->
        <!-- <vs-th sort-key="order_status">Order Status</vs-th>
        <vs-th sort-key="price">Price</vs-th> -->
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.question }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.qtype | title }}</p>
            </vs-td>

            <!-- <vs-td>
              <p class="product-category">{{ tr.status?tr.status:"Draft"}}</p>
            </vs-td> -->

            <!-- <vs-td>
              <vs-chip
                :color="getOrderStatusColor(tr.order_status)"
                class="product-order-status"
                >{{ tr.order_status | title }}</vs-chip
              >
            </vs-td> -->

            <!-- <vs-td>
              <p class="product-price">${{ tr.price }}</p>
            </vs-td> -->

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                @click.stop="editData(tr)"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from "../ui-elements/data-list/DataViewSidebar.vue";
import moduleDataList from "@/store/data-list/moduleDataList.js";
import AddEditNewQuestionnaire from "../apps/health-tracker/AddEditNewQuestionnaire.vue";
import DataProvider from "../../services/data-provider";
import vSelect from "vue-select";
import { bus } from "../../main";

export default {
  components: {
    DataViewSidebar,
    AddEditNewQuestionnaire,
    vSelect,
  },
  data() {
    return {
      selected: [],
      all_question: [],
      items_data: [],
      delete_data: "",
      itemsPerPage: 10,
      isMounted: false,
   db_status:"",
      status:"",
      old_db_status:"",
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    products() {
      return this.$store.state.dataList.products;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
  },
  methods: {
    changeStatus(event) {
      console.log("sdfsdf",event.target.value)
    },
    editData(data) {
      console.log(data);
      bus.$emit(
        "edit_questionnaire",
        data,
        this.all_question,
      );
    },
    changeStatus(event) {
      this.status = event.value;
      console.log(this.status)
      console.log(this.old_db_status)
      if(this.status!=this.old_db_status){
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm Update status ${event.label}`,
        text: `This operation with make this questionnaire ${event.label=="Draft"?"in Draft":'live'}. Are you sure that you would like to proceed?`,
        accept: this.updateStatus,
        cancel:this.cancel,
        acceptText: "Update",
      });
      }
    },
    cancel(){
      console.log("cancel")
      this.status=this.old_db_status
      this.db_status=this.old_db_status
    },
    updateStatus() {
      this.old_db_status=this.status;
      DataProvider.updateData(
        "app_data",
        { status: this.status },
        "health_tracker"
      ).then(
        (re) => {
          console.log("res");
          this.$vs.notify({
        color: "success",
        title: "Updated!",
      });
        },
        (err) => {
          console.log("Err", err);
        }
      );
    },
    getQuestionnaire() {
      DataProvider.getDataFromFirestore("health_tracker").then(
        (res) => {
          console.log(res);
          if (res){
            this.db_status=res.status?res.status:""
            this.old_db_status=res.status?res.status:""
            this.all_question = res.questions;}
          //   this.arrangeData(res.questions);
        },
        (e) => {
          console.log(e);
        }
      );
    },

    arrangeData(items_data) {
      var temparray = [],
        chunk = 10;
      var final_array = [];
      let len = items_data.length;
      for (let i = 1; i <= len; i++) {
        temparray.push(items_data[i - 1]);
        if (i % chunk == 0) {
          final_array.push(temparray);
          temparray = [];
        } else if (i == len) {
          final_array.push(temparray);
          temparray = [];
        }
      }
      console.log(final_array);
      this.all_question = final_array;
      if (final_array.length != 0) {
        this.items_data = final_array[0];
      }
    },
    deleteRecord() {
      console.log("Del record", this.delete_data);
      this.$vs.loading();
      DataProvider.deleteDataFromFirestore(
        "/health-tracker-questionnaire/",
        this.delete_data
      ).then(
        (res) => {
          console.log(res);
          this.showDeleteSuccess();
          this.$vs.loading.close();
          this.getQuestionnaire();
        },
        (err) => {
          console.log("error:", err);
          this.$vs.loading.close();
        }
      );
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Deleted!",
        text: "The selected item was successfully deleted.",
      });
    },
    deleteData(item) {
      this.delete_data = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${item.question}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    // editData(data) {
    //   console.log("edit data", data);
    //   // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
    //   this.sidebarData = data;
    //   this.toggleDataSidebar(true);
    // },
    getOrderStatusColor(status) {
      if (status === "on_hold") return "warning";
      if (status === "delivered") return "success";
      if (status === "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  created() {
    this.getQuestionnaire();
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("dataList", moduleDataList);
      moduleDataList.isRegistered = true;
    }
    this.$store.dispatch("dataList/fetchDataListItems");
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs__selected{
  text-transform: capitalize;
}
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
